/* eslint-disable max-lines */
import { clearURLParams } from 'actions';
import UserInactiveFilter from 'components/Filters/UserInactiveFilter';
import UserIntegrationFilter from 'components/Filters/UserIntegrationFilter';
import UserRolesFilter from 'components/Filters/UserRolesFilter';
import UserTeamsFilter from 'components/Filters/UserTeamsFilter';
import SearchInput from 'components/SearchInput';
import { resourceQueryParamName } from 'constants/resourceQueryNames';
import React from 'react';
import { useDispatch } from 'react-redux';

const AllUsersFilters: React.FC = () => {
  const dispatch = useDispatch();

  const handleClearFilters = (): void => {
    dispatch(clearURLParams());
  };

  return (
    <div className="flex flex-row gap-2 flex-wrap">
      <SearchInput
        resource={resourceQueryParamName.user}
        field="broad_search"
        className="h-8 max-w-68"
        placeholder="Search users by name or email"
      />

      <UserRolesFilter resource={resourceQueryParamName.user} />

      <div className="w-26">
        <UserTeamsFilter kind="division" resource={resourceQueryParamName.user} />
      </div>
      <div className="w-26">
        <UserTeamsFilter kind="region" resource={resourceQueryParamName.user} />
      </div>

      <UserIntegrationFilter resource={resourceQueryParamName.user} />
      <UserInactiveFilter resource={resourceQueryParamName.user} />
      <button
        type="button"
        className="text-body self-end focus:outline-none"
        onClick={handleClearFilters}
      >
        <span className="text-litlingo-primary underline">Clear All</span>
      </button>
    </div>
  );
};

export default AllUsersFilters;
